import React, { useState, useEffect } from "react";
import { io } from "socket.io-client"; // Import Socket.IO client
import {trackEvent} from '../utilities/analytics';
import { useUser } from '../context/UserContext';
const WebSocketProgress = ({ setLoading, toggleModal, selectedSource}) => {
  const [progress, setProgress] = useState(0);
  const { user } = useUser();

    // useEffect(() => {
    //   if (progress === 100) {
    //     setLoading(false);
    //     toggleModal("Success");
    //   }
    // }, [progress, setLoading, toggleModal]);

  useEffect(() => {
    // Connect to the Socket.IO server
    const socket = io(process.env.REACT_APP_BACKEND_URL);

    socket.on('connect', () => {
      console.log('Socket.IO connection opened');
    });

    socket.on('job-progress', (data) => {
      setProgress(data.progress); // Update progress from server
    });

    socket.on('job-completed', async (data) => {
      setLoading(false); // ✅ Hide spinner
      
      // Get pre-import data from window object (set during collision detection)
      const preImportData = window.preImportData || { new: null, existing: null };
      console.log('📊 Pre-import data for modal:', preImportData);
      
      if (data.successCount !== undefined || data.updatedCount !== undefined) {
        toggleModal("Success", data.successCount || 0, data.updatedCount || 0, preImportData.new, preImportData.existing);
      } else {
        toggleModal("Success", null, null, preImportData.new, preImportData.existing);
      }
      console.log('Selected Source:', selectedSource);
      console.log('fileName:', data.fileName);
      console.log('Job completed:', data);

      try {
      console.log("presetName", data.presetName);
        const metadata = {
          fileName: data.fileName,
          importType: selectedSource,
          imported: preImportData.new || 0, // Use pre-import new count instead of actual import count
          updated: preImportData.existing || 0, // Use pre-import existing count instead of actual update count
        };
        if (data.presetName) {
          metadata.presetName = data.presetName;
        }
        console.log("metadata", metadata);

        await trackEvent(user.id, 'File Import', selectedSource || null, metadata);
      }catch(error){
        console.log("Error in trackEvent: ", error);
      }
    });
    
    socket.on('disconnect', () => {
      console.log('Socket.IO connection closed');
    });

    return () => {
      socket.disconnect(); // Clean up on component unmount
    };
  }, []);

  return (
    <div className="w-full flex items-center justify-center py-4">
      <div className="flex flex-col gap-2">
        <div className="relative w-full max-w-md bg-gray-100 rounded-full h-6">
          <div
            className={`absolute top-0 left-0 h-full rounded-full transition-all duration-500 ease-in-out ${
              progress === 100 ? "bg-green-500" : "bg-orange-500"
            }`}
            style={{ width: `${progress}%` }}
          >
            <span
              className={`absolute inset-0 flex items-center justify-center text-white font-semibold ${
                progress <= 10 ? "hidden" : ""
              }`}
            >
              {progress}%
            </span>
          </div>
        </div>
        <div className="text-white text-sm">Importing New Records To Hubspot..</div>
      </div>
    </div>
  );
};

export default WebSocketProgress;
